import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';

Vue.use(require('vue-moment'));
Vue.use(require('vue-the-mask'));

Vue.config.productionTip = false

Vue.filter('formatPrice', function (value) {
  let val = (value/1).toFixed(2).replace('.', ',')
  return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
